/**
 * backend-api
 * LoopBack Application
 *
 * OpenAPI spec version: 4.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ObjectID from './ObjectID';

/**
* The RoleMapping model module.
* @module model/RoleMapping
* @version 4.0.0
*/
export default class RoleMapping {
    /**
    * Constructs a new <code>RoleMapping</code>.
    * Map principals to roles
    * @alias module:model/RoleMapping
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>RoleMapping</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/RoleMapping} obj Optional instance to populate.
    * @return {module:model/RoleMapping} The populated <code>RoleMapping</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new RoleMapping();
                        
            
            if (data.hasOwnProperty('id')) {
                obj['id'] = ObjectID.constructFromObject(data['id']);
            }
            if (data.hasOwnProperty('principalType')) {
                obj['principalType'] = ApiClient.convertToType(data['principalType'], 'String');
            }
            if (data.hasOwnProperty('principalId')) {
                obj['principalId'] = ObjectID.constructFromObject(data['principalId']);
            }
            if (data.hasOwnProperty('roleId')) {
                obj['roleId'] = ObjectID.constructFromObject(data['roleId']);
            }
        }
        return obj;
    }

    /**
    * @member {module:model/ObjectID} id
    */
    id = undefined;
    /**
    * The principal type, such as USER, APPLICATION, ROLE, or user model name in case of multiple user models
    * @member {String} principalType
    */
    principalType = undefined;
    /**
    * @member {module:model/ObjectID} principalId
    */
    principalId = undefined;
    /**
    * @member {module:model/ObjectID} roleId
    */
    roleId = undefined;




}
